



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Scope, check, Scopes } from "@/lib/scope";
import TabBar from "@/basics/tab/TabBar.vue";
import TabItem from "@/basics/tab/TabItem.vue";
import { USER_ME, UserData } from "@/graphql/query/user/me";

export interface AuthTabItem {
  name: string;
  title: string;
  scopes: (Scope<any> | "company.management" | "company.default")[];
}

@Component({
  components: {
    TabBar,
    TabItem
  },
  apollo: {
    me: USER_ME
  }
})
export default class AuthTab extends Vue {
  @Prop({ type: String, required: false }) title!: string;
  @Prop({ type: Array, required: true }) items!: AuthTabItem[];
  me: UserData | null = null;
  @Prop({ type: Boolean, required: false, default: false }) sub!: boolean;

  get enabled(): boolean {
    const index = this.items.findIndex(i => !!this.$route.name!.match(i.name) );
    const allowed = this.scopes(index);
    return check(this.me!.scopes, allowed);
  }

  scopes(index: number): Scopes<any> {
    return this.items[index].scopes.map(s => {
      if (s === "company.management") {
        return {
          resource: "Company",
          resourceId: this.me!.company.id,
          action: "management"
        } as Scope<"Company">;
      }

      if (s === "company.default") {
        return {
          resource: "Company",
          resourceId: this.me!.company.id,
          action: "default"
        } as Scope<"Company">;
      }

      return s as Scope;
    });
  }
}
